/**
 * 后端菜单名称（中文） -> i18n 键，与侧栏、角色权限树一致
 */
export const MENU_LABEL_MAP = {
  '短剧管理': 'menu.videoManagement',
  '短剧列表': 'menu.videoList',
  '弹幕管理': 'menu.barrageManagement',
  '宣传片管理': 'menu.publicizeManagement',
  '敏感词管理': 'menu.sensitiveWordManagement',
  '短剧分类管理': 'menu.videoCategoryManagement',
  '用户购买剧集列表': 'menu.userBuyVideoList',
  '用户管理': 'menu.userManagement',
  '用户信息': 'menu.userInfo',
  '用户提现': 'menu.userWithdraw',
  '用户反馈': 'menu.userFeedback',
  '用户注销管理': 'menu.userCancelManagement',
  '用户报表': 'menu.userReport',
  '用户权益': 'menu.userRights',
  '兑换码': 'menu.exchangeCode',
  '拉人奖励配置': 'menu.referralRewardConfig',
  '会员购买列表': 'menu.vipPurchaseList',
  '签到配置': 'menu.signConfig',
  '任务奖励管理': 'menu.taskRewardManagement',
  '充值管理': 'menu.rechargeManagement',
  '充值菜单管理': 'menu.rechargeMenuManagement',
  '会员菜单管理': 'menu.vipMenuManagement',
  '资源位配置': 'menu.resourcePositionConfig',
  '网址管理': 'menu.urlManagement',
  '帮助中心': 'menu.helpCenter',
  '引导页': 'menu.guidePage',
  '分销配置': 'menu.distributionConfig',
  '轮播图管理': 'menu.carouselManagement',
  '搜索词管理': 'menu.searchWordManagement',
  '头像管理': 'menu.avatarManagement',
  'Tabbar管理': 'menu.tabbarManagement',
  '手机区号管理': 'menu.mobileCodeManagement',
  '财务报表': 'menu.financialReport',
  '短剧报表': 'menu.videoReport',
  '金币充值订单列表': 'menu.coinRechargeOrderList',
  '版本更新': 'menu.versionUpdate',
  '版本管理': 'menu.versionManagement',
  '系统管理': 'menu.systemManagement',
  '用户查询': 'menu.userQuery',
  '用户新增': 'menu.userAdd',
  '用户修改': 'menu.userEdit',
  '用户删除': 'menu.userDelete',
  '用户导出': 'menu.userExport',
  '用户导入': 'menu.userImport',
  '重置密码': 'menu.resetPassword',
  '角色管理': 'menu.roleManagement',
  '角色查询': 'menu.roleQuery',
  '角色新增': 'menu.roleAdd',
  '角色修改': 'menu.roleEdit',
  '角色删除': 'menu.roleDelete',
  '脱敏权限': 'menu.maskPermission',
  '菜单管理': 'menu.menuManagement',
  '菜单查询': 'menu.menuQuery',
  '菜单新增': 'menu.menuAdd',
  '菜单修改': 'menu.menuEdit',
  '菜单删除': 'menu.menuDelete',
  '参数设置': 'menu.paramSettings',
  '参数查询': 'menu.paramQuery',
  '参数新增': 'menu.paramAdd',
  '参数修改': 'menu.paramEdit',
  '参数删除': 'menu.paramDelete',
  '参数导出': 'menu.paramExport',
  '通知公告': 'menu.noticeAnnouncement',
  '公告查询': 'menu.noticeQuery',
  '公告新增': 'menu.noticeAdd',
  '公告修改': 'menu.noticeEdit',
  '公告删除': 'menu.noticeDelete',
  '日志管理': 'menu.logManagement',
  '操作日志': 'menu.operationLog',
  '操作查询': 'menu.operationQuery',
  '操作删除': 'menu.operationDelete',
  '日志导出': 'menu.logExport',
  '登录日志': 'menu.loginLog',
  '登录查询': 'menu.loginQuery',
  '登录删除': 'menu.loginDelete',
  '账户解锁': 'menu.accountUnlock',
  '系统工具': 'menu.systemTools',
  '表单构建': 'menu.formBuilder',
  '代码生成': 'menu.codeGeneration',
  '生成查询': 'menu.generateQuery',
  '生成修改': 'menu.generateEdit',
  '生成删除': 'menu.generateDelete',
  '导入代码': 'menu.importCode',
  '预览代码': 'menu.previewCode',
  '生成代码': 'menu.generateCode',
  '系统接口': 'menu.systemInterface',
  '数据库文档': 'menu.databaseDoc',
  '系统监控': 'menu.systemMonitor',
  '数据监控': 'menu.dataMonitor',
  '服务监控': 'menu.serviceMonitor',
  '缓存监控': 'menu.cacheMonitor',
  '缓存列表': 'menu.cacheList'
}

/**
 * @param {string} label 菜单名称（后端中文或 i18n 键）
 * @param {Function} t vue-i18n $t
 */
export function getMenuLabel (label, t) {
  if (!label || typeof label !== 'string') {
    return label
  }
  if (label.startsWith('route.')) {
    return t(label)
  }
  const i18nKey = MENU_LABEL_MAP[label]
  if (i18nKey) {
    return t(i18nKey)
  }
  return label
}

export default getMenuLabel
